// Local translations
export const T = {
  en_GB: {
    edit: "Edit",
    deleteWithdrawal: "Delete Withdrawal",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This action cannot be undone.`,
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToDelete: "Failed to delete withdrawal",
    ok: "OK",
    noWithdrawals:
      "No planned withdrawals yet. Add withdrawals to see how they affect your expected portfolio value.",
    addWithdrawal: "Add Withdrawal",
    oneTime: "One-time",
    recurring: "Recurring",
    on: "on",
    from: "from",
    noEndDate: (years: number) => `No end date - will use forecast period (${years} years)`,
    until: "Until",
    perMonth: "/month",
    perQuarter: "/quarter",
    perYear: "/year",
  },
  nb_NO: {
    edit: "Rediger",
    deleteWithdrawal: "Slett uttak",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Denne handlingen kan ikke angres.`,
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToDelete: "Kunne ikke slette uttak",
    ok: "OK",
    noWithdrawals:
      "Ingen planlagte uttak ennå. Legg til uttak for å se hvordan de påvirker forventet porteføljeverdi.",
    addWithdrawal: "Legg til uttak",
    oneTime: "Engangs",
    recurring: "Gjentakende",
    on: "den",
    from: "fra",
    noEndDate: (years: number) => `Ingen sluttdato - bruker prognoseperioden (${years} år)`,
    until: "Til",
    perMonth: "/måned",
    perQuarter: "/kvartal",
    perYear: "/år",
  },
} as const;
